/* eslint-disable */
// @ts-nocheck
import { BehaviorSubject } from 'rxjs'
import { Injectable } from '@angular/core'
import { MasterKey } from '../../models/master-key'

@Injectable({
  providedIn: 'root',
})
export class SelectedMasterKeyService {
  constructor() {}

  selectedMasterKey = new BehaviorSubject<MasterKey>(null)
  selectedMasterKey$ = this.selectedMasterKey.asObservable()

  getSelectedMasterKey() {
    return this.selectedMasterKey$
  }

  setSelectedMasterKey(selectedKey: MasterKey) {
    this.selectedMasterKey.next(selectedKey)
  }
}
